import { sendUpdateMessage } from '../../websocket';
function clearTestCase(dispatch, state) {
    dispatch(sendUpdateMessage('scenarioLoad', null));
    dispatch(sendUpdateMessage('scenarioSpeed', 0));
}
export function changePlayMode(playMode) {
    return function (dispatch, getState) {
        if (playMode.type === 'test_scenario' && getState().playing) {
            dispatch(sendUpdateMessage('play', false));
        }
        else if (playMode.type === 'automated' && getState().scenarioPlay) {
            dispatch(sendUpdateMessage('scenarioPlay', false));
        }
        clearTestCase(dispatch, getState());
        dispatch(sendUpdateMessage('playMode', playMode));
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/containers/ModeChooserTabs/actions.ts
// module id = 1823
// module chunks = 0